module.exports = __webpack_public_path__ + "static/img/honor6.a49ee05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/honor/honor6.png
// module id = F5KQ
// module chunks = 0